import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import errorMessages from '../errorsFa';

import { messageActions, generalActions, generalSelectors } from 'Ducks';
import { SAGA_REQUEST_KEY, GLOBALS } from 'Constants';
import routes from 'Pages/router/constants/routes';
import storeContainer from 'Config/redux/store';
import { getLocalAuth } from 'Helpers';

export function* sagaCallService(service, action, params = {}) {
	const currentStore = storeContainer.store.getState();
	const loadingName =
		action.type + `${params?.[SAGA_REQUEST_KEY.LOADING_ID] || ''}`;

	if (generalSelectors.selectApiLoadingStatus(currentStore, loadingName)) {
		return;
	}

	try {
		yield put(generalActions.startApiLoading(loadingName));

		const config = yield call(getRequestConfig, service, action, params);

		const response = yield call(axios, config);

		yield put(generalActions.stopApiLoading(loadingName));
		return response;
	} catch (e) {
		yield put(generalActions.stopApiLoading(loadingName));
		throw e;
	}
}

export function* sagaErrorDispatcher(e, action, callbackAction, isArrayMsg) {
	console.error('api request error =>', e?.response || e, action);
	let errorMessage =
		e?.response?.data?.message ||
		e?.response?.data?.msg ||
		e?.response?.data?.error;
	const status = e?.response?.status;
	const isTimeout = e?.code === 'ECONNABORTED';
	const isNetworkError = e?.message?.toLowerCase()?.includes('network error');
	const isIranAccess = status === 403;

	const currentPage = window?.location?.pathname?.replace(/\//g, '_') || 'root';
	const IRAN_ACCESS_KEY = `iran_access_block_${currentPage}`;

	const IRAN_ACCESS_EXPIRY = 1000 * 10;
	const now = Date.now();

	let storedData = null;
	try {
		storedData = JSON.parse(localStorage.getItem(IRAN_ACCESS_KEY));
	} catch (err) {
		console.warn('Invalid iran_access_block key in localStorage');
	}

	let shouldShow403Toast = true;
	if (isIranAccess) {
		if (storedData?.isActive && storedData?.expireAt > now) {
			shouldShow403Toast = false;
		} else {
			const newData = { isActive: true, expireAt: now + IRAN_ACCESS_EXPIRY };
			localStorage.setItem(IRAN_ACCESS_KEY, JSON.stringify(newData));
			shouldShow403Toast = true;
		}
	}
	const isArrayMessage = Array.isArray(errorMessage);
	const isFieldErrorObject =
		errorMessage && typeof errorMessage === 'object' && !isArrayMessage;
	// flatten field errors into one readable string (or just grab the first one)
	const flattenFieldErrors = (obj) => {
		const firstKey = Object.keys(obj)[0];
		const firstVal = obj[firstKey];
		return Array.isArray(firstVal) ? firstVal[0] : String(firstVal);
	};
	errorMessage = isIranAccess
		? errorMessages[403]
		: isTimeout
		? errorMessages.TIMEOUT
		: isNetworkError
		? errorMessages.NETWORK
		: typeof errorMessage === 'string'
		? errorMessage
		: isFieldErrorObject
		? flattenFieldErrors(errorMessage)
		: isArrayMsg === true || isArrayMessage === true
		? errorMessage[0]
		: errorMessages[status] || errorMessages.default;

	const resolvedToastTime =
		typeof action.toastTime === 'number'
			? action.toastTime
			: GLOBALS.TOAST_TIMEOUT.DEFAULT;
	if (errorMessage === 'پیش از ادامه باید وارد شوید یا ثبت نام کنید.') {
		yield put(
			messageActions.pushErrorToast({
				title: errorMessage,
				toastTime: resolvedToastTime,
			})
		);
		window.location.href = `/pwa${routes.login}`;
		return;
	}
	const disableToast = action?.payload?.[SAGA_REQUEST_KEY.DISABLE_TOAST];
	const canShowToast =
		!disableToast && (!isIranAccess || shouldShow403Toast === true);
	yield put(generalActions.stopApiLoading(action.type));

	canShowToast &&
		(yield put(
			messageActions.pushErrorToast({
				title: errorMessage,
				toastTime: resolvedToastTime,
			})
		));
	if (callbackAction) yield put(callbackAction(e));
}

function getRequestConfig(service, action, params) {
	const { auth } = getLocalAuth() || {};

	const config = {
		timeout: 10000,
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		...service(params),
	};
	if (params?.forceMasterToken && auth?.masterToken) {
		config.headers['Authorization'] = `Bearer ${auth.masterToken}`;
	} else if (auth?.activeBusinessToken) {
		config.headers['Authorization'] = `Bearer ${auth.activeBusinessToken}`;
	}

	return config;
}
